import type {UseMutationResult} from '@tanstack/react-query';
import {useMutation, useQueryClient} from '@tanstack/react-query';
import useApiFetch from '@/components/MSAL/useApiFetch';
import type {CapacityOverrideWithLabel} from '@/types/CapacityOverride';
import {apiUrl} from '@/utils/api';

export const useAddCapacityOverride = () : UseMutationResult<
    void,
    unknown,
    CapacityOverrideWithLabel
> => {
    const fetch = useApiFetch();
    const queryClient = useQueryClient();

    return useMutation(async (values : CapacityOverrideWithLabel) => {
        try {
            await fetch(apiUrl('/v1/capacity/capacity/add-override').toString(), {
                method: 'PUT',
                body: JSON.stringify(values),
            });
        } catch (e : unknown) {
            throw new Error('Unable to add capacity default.');
        }
    }, {
        onSuccess: async () => {
            await queryClient.invalidateQueries(['capacityCombined']);
            await queryClient.invalidateQueries(['capacityLabels']);
        },
    });
};
